import {createDomainEvent, DomainEvent} from './domain-event'

export const PageEventTypes = {
  Redirect: 'page.redirect',
} as const

interface PageRedirectPayload {
  url: string
}

export type PageRedirectEvent = DomainEvent<PageRedirectPayload>

export const PageEvents = {
  redirect(payload: PageRedirectPayload): PageRedirectEvent {
    return createDomainEvent(PageEventTypes.Redirect, payload)
  },
}
